// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Nj_b2","validationTips":"StatementDescriptor_validationTips__3FQ0Q"};